import { gql } from '@apollo/client';

export default gql`
  mutation NamedBucketDefDelete($input: NamedBucketDefDeleteInput!) {
    namedBucketDefDelete(input: $input) {
      message
      errors {
        field
        messages
      }
    }
  }
`;
